/* eslint-disable class-methods-use-this */
/* eslint max-classes-per-file: ["error", 2] */

'use strict';

define('vb/private/types/metadataDescriptor',[
  'vb/private/log',
  'vb/helpers/mixin',
  'vb/private/types/builtinExtendedTypeMixin',
], (Log, Mixin, BuiltinExtendedTypeMixin) => {
  /**
   * custom variable type for metadata providers
   *
   * note: using "class {}" instead of Object, babel issue: https://github.com/babel/babel/issues/4480
   *
   */
  class MetadataDescriptor extends Mixin().with(BuiltinExtendedTypeMixin) {
    constructor() {
      super();
      this.log = Log.getLogger('/vb/types/metadataDescriptor');
    }

    /**
     * Initializer.
     * @param id
     * @param variableDef the declarative definition of this variable
     * @param value the defaultValue is provided here
     * @param container app, flow, or page. needed to pass context to the provider
     * @return {Promise}
     * @constructor
     */
    init(id, variableDef, value, container) {
      return Promise.resolve()
        .then(() => {
          super.init(id, variableDef, value, container);
          this.container = container;
        });
    }

    /**
     *
     * @returns {*}
     */
    getTypeDefinition() {
      return {
        type: 'object',
      };
    }
  }

  return MetadataDescriptor;
});

